import styled from 'styled-components'
import zIndex from 'styles/tools/z-index'

/** Shared z-index base for slide content that needs to appear above navigation arrows */
export const TAP_ZONE_Z_INDEX = zIndex.tooltip

/**
 * Wrap interactive elements (buttons, links) to prevent tap-zone navigation.
 * The navigation system skips clicks on elements with data-interactive-zone.
 */
const InteractiveZone = styled.div.attrs<{ 'data-interactive-zone'?: string }>({
  'data-interactive-zone': 'true',
})`
  width: 100%;
  position: relative;
  z-index: ${TAP_ZONE_Z_INDEX + 3};
`

export default InteractiveZone
